import React from 'react'

import SiteContainer from '../../Containers/SiteContainer/SiteContainer'
import AnimatedBlob from '../../Components/AnimatedBlob/AnimatedBlob'
import BackDrop from '../../Components/BackDrop/BackDrop'
import Content from '../../Components/Content/Content'
import Columns from '../../Components/Columns/Columns'
import Divider from '../../Components/Divider/Divider'
import Hero from '../../Components/Hero/Hero'
import OurTeam from '../../Components/OurTeam/OurTeam'
import Languages from '../../Components/Languages/Languages'
import './AboutUsPage.css'

const AboutUsPage = () => {
  return (
    <SiteContainer>
      <Hero title="About Us" modifiers={['fmbm-hero--center']}>
        <div className="fmbm-hero__small-text wow fadeIn">
          Learn more about who we are and how we work
        </div>
      </Hero>
      <Divider />
      <Content>
        <AnimatedBlob hiddenMobile />
        <Columns number={2}>
          <div>
            <BackDrop color="purple">
              <img
                alt=""
                src="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/workpics%2Fmishall-mike-problem-solving.png?alt=media&token=81626d88-9cad-4f5d-b9d5-86c70424e603"
              />
            </BackDrop>
          </div>
          <div>
            <h1>We welcome challenges</h1>
            <p>
              On our spare time, if we're not working on our hobby projects,
              we're looking for other problems to solve. At For Makers by
              Makers, we employ the type of people who jump at the oppurtunity
              to solve a complex problem. Have an interesting problem you're
              trying to solve?{' '}
              <a href="https://goo.gl/forms/Ic1vg0nIpl8qfdi22">let us know</a>.
            </p>
          </div>
        </Columns>
      </Content>
      <Divider />
      <Content>
        <Columns number={2} disableReverse>
          <div>
            <h1>Collaborative</h1>
            <p>
              We're not just concerned with the end result of your product,
              although we are extremely goal oriented. Our team is aware that
              the journey is just as important. For those reasons, we include
              you in every step of our process. That's where the magic happens.
              After all, we are here as your partner. Our goal is to help you
              build a great product, not simply finish a quick project. This is
              why we hand select the people we work with, working with fewer
              clients for longer periods of time. Allowing us to truly
              understand the problem that you and your product are trying to
              solve.
            </p>
          </div>
          <div>
            <BackDrop>
              <img
                alt=""
                src="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/workpics%2Fcollab-w-gist.png?alt=media&token=b6de099b-8fb8-4f85-83af-dec6469dda27"
              />
            </BackDrop>
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile right />
      </Content>
      <Divider />
      <Content>
        <AnimatedBlob hiddenMobile />
        <Columns number={2}>
          <div>
            <BackDrop color="blue">
              <img
                alt=""
                src="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/workpics%2Fmike-michael-exploratorium.png?alt=media&token=ad7cdde8-1be8-4926-b64c-37e4b12e41de"
              />
            </BackDrop>
          </div>
          <div>
            <h1>Innovation meets experience</h1>
            <p>
              Even though we've been working with technology long enough to
              establish a go-to set of tools, we don't let that tarnish our
              ability to be innovative. Whether that means working with new
              technology or just finding new ways to make existing technology
              better.
            </p>
            <p>
              With our team being experienced in over 15 languages & even more
              different types of software, you can rest assure that we'll come
              up with a tailored strategy, specific to your needs. Meaning your
              product won't have to fit within our contraints. Typically, in the
              development cycle, a startup founder tends to have to dream within
              the constraints of what their developers know. With our team,
              there are truly no limits.
            </p>
          </div>
        </Columns>
      </Content>
      <Divider />
      <OurTeam />
      <Divider />
      <Languages />
    </SiteContainer>
  )
}

export default AboutUsPage



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/AboutUsPage.js